module.exports = __webpack_public_path__ + "img/hr-concrete-inner-corner.f80a685c.png";